module.exports = __webpack_public_path__ + "static/for-the-sales-FA.abf130ae.gif";


//////////////////
// WEBPACK FOOTER
// ./src/sections/signupPage/forTheSales/images/for-the-sales-FA.gif
// module id = 1705
// module chunks = 168707334958949